import React from 'react';
import {IButtonProps} from '../../types';

export const CountdownButton: React.FC<IButtonProps> = ({
    label,
    className,
    onClick,
    onlyIcon,
    icon
}) => (
    <button className={className} onClick={onClick}>
        {onlyIcon ? <img src={icon} /> : label}
    </button>
);
